import React, { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppOrgContext } from "../../context/AppOrgContext";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import { getModulePath, headerModes } from "./navbarUtils";

const HeaderModes = () => {
  const { setMode, mode } = useAppOrgContext();
  const { appId, orgId } = useParams();
  const navigate = useNavigate();

  const handleModeChange = useCallback(
    (newMode, route) => {
      if (mode !== newMode) {
        setMode(newMode);
        navigate(getModulePath(route, orgId, appId));
      }
    },
    [mode, setMode, navigate, orgId, appId]
  );

  return (
    <div className="top_navbar_mode_wrapper">
      {headerModes.map(({ icon, title, mode: itemMode, route }) => (
        <div
          key={title}
          className={`top_navbar_single_mode ${mode === itemMode ? "active" : ""}`}
          onClick={() => handleModeChange(itemMode, route)}
          aria-label={`Switch to ${title} mode`}
        >
          <MaterialIcon name={icon} className="cursor_pointer" style={{ fontSize: "24px" }} />
          <label className="navbar_item_name mb_0 cursor_pointer" style={{ fontSize: "10px" }}>
            {title}
          </label>
        </div>
      ))}
    </div>
  );
};

export default HeaderModes;
